const SUBJECT_CHOICE = [
  {
    name: '小学',
    value: 1,
    subs: [
      {
        name: '小学语文',
        value: 101,
        nick: 'CHINESE'
      },
      {
        name: '小学数学',
        value: 102,
        nick: 'MATH'
      },
      {
        name: '小学英语',
        value: 103,
        nick: 'ENGLISH'
      }
    ]
  },
  {
    name: '初中',
    value: 2,
    subs: [
      {
        name: '初中语文',
        value: 201,
        nick: 'CHINESE'
      },
      {
        name: '初中数学',
        value: 202,
        nick: 'MATH'
      },
      {
        name: '初中英语',
        value: 203,
        nick: 'ENGLISH'
      },
      {
        name: '初中物理',
        value: 204,
        nick: 'PHYSICS'
      },
      {
        name: '初中化学',
        value: 205,
        nick: 'CHEMISTRY'
      },
      {
        name: '初中生物',
        value: 206,
        nick: 'BIOLOGY'
      },
      {
        name: '初中政治',
        value: 207,
        nick: 'POLITICS'
      },
      {
        name: '初中地理',
        value: 208,
        nick: 'GEOGRAPHY'
      },
      {
        name: '初中历史',
        value: 209,
        nick: 'HISTORY'
      }
    ]
  },
  {
    name: '高中',
    value: 3,
    subs: [
      {
        name: '高中语文',
        value: 301,
        nick: 'CHINESE'
      },
      {
        name: '高中数学',
        value: 302,
        nick: 'MATH'
      },
      {
        name: '高中英语',
        value: 303,
        nick: 'ENGLISH'
      },
      {
        name: '高中物理',
        value: 304,
        nick: 'PHYSICS'
      },
      {
        name: '高中化学',
        value: 305,
        nick: 'CHEMISTRY'
      },
      {
        name: '高中生物',
        value: 306,
        nick: 'BIOLOGY'
      },
      {
        name: '高中政治',
        value: 307,
        nick: 'POLITICS'
      },
      {
        name: '高中地理',
        value: 308,
        nick: 'GEOGRAPHY'
      },
      {
        name: '高中历史',
        value: 309,
        nick: 'HISTORY'
      }
    ]
  }
]

export { SUBJECT_CHOICE }
